import keyMirror from 'keymirror';

export const AppName = {
    BOOKING_ENGINE: 'booking-engine',
    DELAY_REPAY: 'delay-repay',
    SEARCH_WIDGETS: 'otrl-search-widgets',
};

export const TimeZone = 'Europe/London';

export const KeyCodes = {
    ENTER: 13,
    LEFT_ARROW: 37,
    RIGHT_ARROW: 39,
    UP_ARROW: 38,
    DOWN_ARROW: 40,
};

// GTR brands used for cross-brand refunds
export const Brands = {
    GN: 'greatnorthern',
    TL: 'thameslink',
    SN: 'southern',
    GX: 'gatwick',
};

export const TicketTypes = {
    SINGLE: 'single',
    RETURN: 'return',
    OPEN_RETURN: 'open-return',
};

export const PassengerTypes = {
    ADULT: 'adult',
    CHILD: 'child',
};

export const GroupSavePassengers = {
    MIN: 3,
    MAX: 9,
};

export const DefaultPagination = {
    LIMIT: '3',
    PAGE: '1',
};

export const AuthGrantTypes = {
    AMAZON_AUTH_CODE: 'amazon_authorization_code',
    PASSWORD: 'password',
    REFRESH_TOKEN: 'refresh_token',
};

export const IdentityProviders = {
    AMAZON: 'amazon',
};

export const ActionTypes = keyMirror({
    APP_INITIALIZED: null,
    WINDOW_RESIZED: null,
    ACTIVITY_DETECTED: null,
    ROUTE_CHANGED: null,

    SEARCH_LOADED: null,
    SEARCH_UPDATED: null,
    SEARCH_STARTED: null,
    SEARCH_FAILED: null,
    SEARCH_FINISHED: null,

    RESET_JOURNEY_STORE: null,

    CHECK_TOC_ONLY_ADD: null,
    CHECK_TOC_ONLY_UPDATE: null,

    SEASON_SEARCH_LOADED: null,
    SEASON_SEARCH_UPDATED: null,
    SEASON_SEARCH_STARTED: null,
    SEASON_SEARCH_FAILED: null,
    SEASON_SEARCH_FINISHED: null,
    SEASON_TICKET_SELECTED: null,
    SEASON_TICKET_PHOTOCARD_UPDATED: null,
    SEASON_TICKET_PHOTOCARD_FIELD_UPDATED: null,
    SEASON_TICKET_PHOTOCARD_CLEAR: null,

    FARE_ONLY_SEARCH_STARTED: null,
    FARE_ONLY_SEARCH_FAILED: null,
    FARE_ONLY_SEARCH_FINISHED: null,

    FARE_ONLY_SEASON_SEARCH_STARTED: null,
    FARE_ONLY_SEASON_SEARCH_FAILED: null,
    FARE_ONLY_SEASON_SEARCH_FINISHED: null,

    ELIGIBLE_SERVICES_SEARCH_STARTED: null,
    ELIGIBLE_SERVICES_SEARCH_FINISHED: null,
    ELIGIBLE_SERVICES_SEARCH_FAILED: null,
    ELIGIBLE_SERVICES_RESET: null,

    SMART_CARNET_SEARCH_LOADED: null,
    SMART_CARNET_SEARCH_STARTED: null,
    SMART_CARNET_SEARCH_FAILED: null,
    SMART_CARNET_SEARCH_FINISHED: null,
    SMART_CARNET_SEARCH_SELECTED: null,
    SMART_CARNET_RETURN_SEARCH_STARTED: null,
    SMART_CARNET_RETURN_SEARCH_FAILED: null,
    SMART_CARNET_RETURN_SEARCH_FINISHED: null,
    SMART_CARNET_RETURN_SEARCH_SELECTED: null,
    SMART_CARNET_FILTER_CHANGED: null,
    SMART_CARNET_PASSES_STARTED: null,
    SMART_CARNET_PASSES_FAILED: null,
    SMART_CARNET_PASSES_FINISHED: null,
    SMART_CARNET_RETURN_CLOSED: null,
    SMART_CARNET_TICKET_DETAILS_STARTED: null,
    SMART_CARNET_TICKET_DETAILS_FAILED: null,
    SMART_CARNET_TICKET_DETAILS_FINISHED: null,
    SMART_CARNET_TICKETS_STARTED: null,
    SMART_CARNET_TICKETS_FAILED: null,
    SMART_CARNET_TICKETS_FINISHED: null,

    INWARD_SERVICE_SELECTED: null,
    OUTWARD_SERVICE_SELECTED: null,

    FARE_SELECTED: null,
    FARE_ONLY_SELECTED: null,
    FARE_CATEGORY_SELECTED: null,
    FARE_STAGE_CHANGED: null,

    SELECTING_CHEAPEST_FARE: null,
    SELECTING_NON_CHEAPEST_FARE: null,

    DELIVERY_METHOD: null,
    PAYMENT_METHOD: null,

    ORDER_LOADING: null,
    ORDER_STARTED: null,
    ORDER_CREATED: null,
    ORDER_UPDATED: null,
    ORDER_FAILED: null,
    ORDER_TRIP_CREATED: null,
    ORDER_TRIP_UPDATED: null,
    ORDER_TRIP_DELETED: null,
    ORDER_TRIP_LEAD_PASSENGER_UPDATED: null,
    ORDER_PAID: null,
    BASKET_CLEARED: null,
    ORDER_DELIVERY_OPTIONS_LOADED: null,
    ORDER_DELIVERY_OPTIONS_LOADING: null,
    ORDER_PLUSBUS_UPDATED: null,
    ORDER_EXPIRED: null,
    ORDER_TAXI_BOOKING_AVAILABILITY: null,
    UTN_DETAILS: null,
    ORDER_CONTACT_DETAILS_UPDATED: null,
    POSTAL_FULFILMENT_STORED_ADDRESS_UPDATED: null,
    ORDER_HANDOFF_UPDATED: null,
    ORDER_HANDOFF_REFERRAL_REPORTED: null,
    LINK_ORDER_TO_ACCOUNT: null,

    ORDER_LOAD_STARTED: null,
    ORDER_LOADED: null,
    ORDER_LOAD_FAILED: null,

    APPLY_DISCOUNT_CODE_STARTED: null,
    APPLY_DISCOUNT_CODE_FAILED: null,
    APPLY_DISCOUNT_CODE_FINISHED: null,

    DELETE_DISCOUNT_CODE_STARTED: null,
    DELETE_DISCOUNT_CODE_FAILED: null,
    DELETE_DISCOUNT_CODE_FINISHED: null,

    ORDER_LOCKED: null,
    ORDER_UNLOCKED: null,

    SERVICE_SELECTED: null,
    LEG_SELECTED: null,

    TRIP_UPDATED: null,
    TRIP_PLUSBUS_AVAILABILITY_LOADED: null,

    FULFILMENT_UPDATED: null,
    FULFILMENT_METHOD_UPDATED: null,

    REGISTRATION_STARTED: null,
    REGISTRATION_FAILED: null,
    REGISTRATION_SUCCESS: null,

    LOGGED_IN: null,
    LOGGED_OUT: null,
    AUTH_LOADED: null,
    AUTH_REFRESH_STARTED: null,
    AUTH_REFRESHED: null,
    AUTH_ERROR: null,
    USER_UPDATED: null,
    CHECK_EMAIL: null,
    USER_PREFERENCES_UPDATED: null,
    USER_PREFERENCES_FETCHED: null,

    GET_CONSENTS_TEMPLATE_STARTED: null,
    GET_CONSENTS_TEMPLATE_SUCCESS: null,
    GET_CONSENTS_TEMPLATE_FAILED: null,
    GET_CONSENTS_TEMPLATE_FINISHED: null,

    GET_USER_CONSENTS_STARTED: null,
    GET_USER_CONSENTS_SUCCESS: null,
    GET_USER_CONSENTS_FAILED: null,
    GET_USER_CONSENTS_FINISHED: null,

    UPDATE_USER_CONSENTS_STARTED: null,
    UPDATE_USER_CONSENTS_SUCCESS: null,
    UPDATE_USER_CONSENTS_FAILED: null,
    UPDATE_USER_CONSENTS_FINISHED: null,

    SET_CONSENTS_FORM: null,

    MODAL_OPENED: null,
    MODAL_CLOSED: null,
    GENERIC_MODAL_OPEN: null,

    PAYMENT_FORM_CHANGED: null,
    PAYMENT_FORM_ERROR_MESSAGE: null,
    PAYMENT_DISCOUNT_CODE_CHANGED: null,
    PAYMENT_AUTH_STARTED: null,
    PAYMENT_AUTH_FINISHED: null,
    PAYMENT_AUTH_FAILED: null,
    PAYMENT_AUTH_RESET: null,
    PAYMENT_AUTH_WAITING: null,
    PAYMENT_PRE_AUTH_VOUCHERS_STARTED: null,
    PAYMENT_PRE_AUTH_VOUCHERS_RELEASED: null,
    PAYMENT_PRE_AUTH_VOUCHERS_COMPLETED: null,
    PAYMENT_LEFT: null,

    ORDER_REFRESH_STARTED: null,
    ORDER_REFRESH_LOADED: null,
    ORDER_REFRESH_FAILED: null,

    CALLING_POINTS_LOAD_STARTED: null,
    CALLING_POINTS_LOADED: null,
    CALLING_POINTS_LOAD_FAILED: null,

    ACCOUNT_DRC_LOADED: null,
    SET_FAVOURITE_DRC: null,
    REMOVED_DRC_DEVICE: null,

    RAILCARDS_LOAD_STARTED: null,
    RAILCARDS_LOADED: null,
    RAILCARDS_LOAD_FAILED: null,

    RAILCARD1617_CHECKED: null,
    RAILCARD1617_FLASH_CHECKBOX: null,
    RAILCARD1617_FORM_CHANGED: null,
    RAILCARD1617_LOAD_FAILED: null,
    RAILCARD1617_LOAD_STARTED: null,
    RAILCARD1617_LOADED: null,
    RAILCARD1617_REMOVE: null,
    RAILCARD1617_RESET_VALIDATION: null,
    RAILCARD1617_VALIDATION_COMPLETED: null,
    RAILCARD1617_VALIDATION_FAILED: null,
    RAILCARD1617_VALIDATION_STARTED: null,

    RAILCARD_JOBCENTREPLUS_CHECKED: null,

    IN_APP_SESSION_STARTED: null,
    DEVICE_TOKEN_UPDATED: null,
    SEARCH_WIDGET_LOADED: null,
    MOBILE_APP_RATING_TRIGGERED: null,
    MOBILE_APP_RE_ORDER: null,

    WIDGET_AUTH_SESSION_STARTED: null,

    LOADING_STARTED: null,
    LOADING_COMPLETED: null,
    LOADING_FAILED: null,
    LOADING_STOPPED: null,

    SHOW_EARLIER_TRAINS_STARTED: null,
    SHOW_EARLIER_TRAINS_FINISHED: null,
    SHOW_LATER_TRAINS_STARTED: null,
    SHOW_LATER_TRAINS_FINISHED: null,

    BANNER_DISMISSED: null,
    BANNER_CONFIG_LOADED: null,

    JOURNEY_NOTIFICATIONS_DISMISSED: null,
    JOURNEY_NOTIFICATIONS_LOADED: null,

    ADDRESSES_LOADED: null,
    ADDRESS_CREATED: null,
    ADDRESS_DELETED: null,
    ADDRESS_UPDATED: null,

    PHOTOCARDS_LOADED: null,
    PHOTOCARD_CREATED: null,
    PHOTOCARD_DELETED: null,

    ACCOUNT_RAILCARDS_LOADED: null,
    NEWLY_APPROVED_RAILCARDS_LOADED: null,
    ACCOUNT_RAILCARD_DELETED: null,
    RAILCARD_APPLICATION_SUBMITTED: null,

    NOTIFICATION_SHOW: null,
    NOTIFICATION_HIDE: null,

    SEASON_RESULTS_FILTERS_CHANGE: null,

    DISCOUNT_LOADED: null,
    DISCOUNT_LOAD_FAILED: null,

    PROMOCODE_APPLIED: null,
    PROMOCODE_REMOVED: null,

    CUSTOMER_VOUCHERS_STARTED: null,
    CUSTOMER_VOUCHERS_LOADED: null,
    CUSTOMER_VOUCHERS_FAILED: null,

    CUSTOMER_ORDERS_SEARCHING: null,
    CUSTOMER_ORDERS_LOADED: null,
    CUSTOMER_ORDER_LOADED: null,

    CUSTOMER_PAYMENTCARDS_STARTED: null,
    CUSTOMER_PAYMENTCARDS_LOADED: null,
    CUSTOMER_PAYMENTCARD_DELETED: null,

    SMARTCARD_STARTED: null,
    SMARTCARD_LOADED: null,
    SMARTCARD_FAILED: null,
    SMARTCARD_FAILURE_NOTIFIED: null,
    SMARTCARD_DIRTY: null,
    SMARTCARD_REGISTERED: null,
    SMARTCARD_LINKED: null,
    SMARTCARDS_LOADED: null,
    SMARTCARD_JOURNEYS_LOADED: null,
    SMARTCARD_ACTIVATION_STARTED: null,
    SMARTCARD_ACTIVATION_FAILED: null,
    SMARTCARD_ACTIVATED: null,
    SMARTCARD_PAPER_TRANSFER_COMPLETE: null,
    SMARTCARD_SET_SHOW_COLLECTION_LOCATION: null,
    SMARTCARD_ASSOCIATED_SMARTCARDS_LOADED: null,
    SMARTCARD_ASSOCIATED_ACCOUNTS_LOADED: null,
    SMARTCARD_ASSOCIATION_COMPLETED: null,
    SMARTCARD_ASSOCIATION_REMOVED: null,
    SMARTCARD_TO_ASSOCIATE_LOADED: null,

    SMARTCARD_CTA_DISMISSED: null,

    LINKING_SMARTCARDS_LINK: null,

    CHECK_USER_COOKIE: null,

    KEYGO_FORM_CHANGED: null,
    KEYGO_ADDRESS_SELECTED: null,
    KEYGO_FORM_RETRY: null,
    KEYGO_REGISTRATION_STARTED: null,
    KEYGO_REGISTRATION_COMPLETE: null,
    KEYGO_REGISTRATION_FAILED: null,
    KEYGO_CANCELLED: null,
    KEYGO_UPDATE_STARTED: null,
    KEYGO_UPDATE_COMPLETE: null,
    KEYGO_UPDATE_FAILED: null,
    KEYGO_FORM_RESET: null,
    KEYGO_TAPS_LOADED: null,
    KEYGO_TRANSACTIONS_LOADED: null,
    KEYGO_TRANSACTIONS_LOADING: null,

    REPLACEMENT_SMARTCARD_REQUESTED: null,

    DAYSAVE_SEARCH_LOADED: null,
    DAYSAVE_SEARCH_STARTED: null,
    DAYSAVE_SEARCH_FINISHED: null,
    DAYSAVE_SEARCH_FAILED: null,
    DAYSAVE_TICKET_SELECTED: null,

    ROVERSRANGERS_SEARCH_LOADED: null,
    ROVERSRANGERS_SEARCH_STARTED: null,
    ROVERSRANGERS_SEARCH_FINISHED: null,
    ROVERSRANGERS_SEARCH_FAILED: null,
    ROVERSRANGERS_TICKET_SELECTED: null,
    ROVERSRANGERS_TICKET_PASSENGERS_CHANGED: null,

    UNSUBSCRIBE_STARTED: null,
    UNSUBSCRIBE_COMPLETE: null,
    UNSUBSCRIBE_FAILED: null,

    REFUND_CONFIG_STARTED: null,
    REFUND_CONFIG_LOADED: null,
    REFUND_CONFIG_FAILED: null,
    REFUND_DETAILS_STARTED: null,
    REFUND_DETAILS_LOADED: null,
    REFUND_DETAILS_FAILED: null,
    REFUND_CALCULATIONS_STARTED: null,
    REFUND_CALCULATIONS_LOADED: null,
    REFUND_ITSO_CALCULATIONS_LOADED: null,
    REFUND_CALCULATIONS_FAILED: null,
    REFUND_UPDATED: null,
    REFUND_STARTED: null,
    REFUND_COMPLETE: null,
    REFUND_FAILED: null,
    REFUND_RESET: null,

    AMEND_CANCELLED: null,
    AMEND_CANCEL_FAILED: null,
    AMEND_CANCEL_STARTED: null,
    AMEND_CONFIG_FAILED: null,
    AMEND_CONFIG_LOADED: null,
    AMEND_CONFIG_LOADING: null,
    AMEND_FARE_SELECTED: null,
    AMEND_ORDER_CANCEL: null,
    AMEND_ORDER_REFRESHED: null,
    AMEND_PAYMENT_AUTH_FINISHED: null,
    AMEND_RESET: null,
    AMEND_SEARCH_FAILED: null,
    AMEND_SEARCH_FINISHED: null,
    AMEND_SEARCH_LOADED: null,
    AMEND_SEARCH_STARTED: null,
    AMEND_SEARCH_UPDATED: null,
    AMEND_SERVICE_SELECTED: null,
    AMEND_SET_FAILED: null,
    AMEND_SET_STARTED: null,
    AMEND_SHOW_EARLIER_TRAINS_FINISHED: null,
    AMEND_SHOW_EARLIER_TRAINS_STARTED: null,
    AMEND_SHOW_LATER_TRAINS_FINISHED: null,
    AMEND_SHOW_LATER_TRAINS_STARTED: null,
    AMEND_TOOK_PAYMENT: null,
    AMEND_TRIP_FAILED: null,
    AMEND_TRIP_FINISHED: null,
    AMEND_TRIP_STARTED: null,
    AMEND_PLUSBUS_SET: null,
    AMEND_UPDATED: null,
    AMEND_CTA_CLICKED: null,
    AMEND_CONFIRMED: null,

    AMAZON_LOGIN_LOGIN_ACCESS_TOKEN: null,
    AMAZON_LOGIN_EMAIL: null,
    AMAZON_LOGIN_PROCESSING_FINISHED: null,
    AMAZON_LOGIN_PROCESSING_STARTED: null,
    AMAZON_LOGIN_STATUS: null,

    AMAZON_PAY_ADDRESS_ERROR: null,
    AMAZON_PAY_CLEAR_ERROR: null,
    AMAZON_PAY_ERROR: null,
    AMAZON_PAY_INVALID_PAYMENT_METHOD: null,
    AMAZON_PAY_LOGIN_COMPLETE: null,
    AMAZON_PAY_LOGOUT: null,
    AMAZON_PAY_MFA_SUCCESSFUL: null,
    AMAZON_PAY_PROCESSING: null,

    PAYPAL_CLIENT_TOKEN_LOADED: null,
    PAYPAL_PAYMENT_METHOD_RECEIVED: null,
    PAYPAL_ADDRESS_ERROR: null,
    PAYPAL_CHECKOUT: null,

    BRAINTREE_CLIENT_TOKEN_LOADED: null,
    BRAINTREE_PAYMENT_METHOD_RECEIVED: null,
    BRAINTREE_CHECKOUT: null,

    PAY360_SESSION_CREATE_STARTED: null,
    PAY360_SESSION_CREATED: null,
    PAY360_SESSION_LOADED: null,

    DELAY_REPAY_CUSTOMER_UPDATED: null,
    DELAY_REPAY_AGE_TOGGLED: null,
    DELAY_REPAY_USER_ADDED: null,
    DELAY_REPAY_SMARTCARD_ADDED: null,
    DELAY_REPAY_CLAIM_ADDED: null,
    DELAY_REPAY_CLAIM_UPDATED: null,
    DELAY_REPAY_CLAIM_REMOVED: null,
    DELAY_REPAY_CLAIM_CLONED: null,
    DELAY_REPAY_CLAIM_FILE_SELECTED: null,
    DELAY_REPAY_UPLOAD_STARTING: null,
    DELAY_REPAY_UPLOAD_COMPLETE: null,
    DELAY_REPAY_UPLOAD_FAILED: null,
    DELAY_REPAY_UPLOAD_CANCELLED: null,
    DELAY_REPAY_PAYMENT_UPDATED: null,
    DELAY_REPAY_SUBMITTING: null,
    DELAY_REPAY_SUBMITTED: null,
    DELAY_REPAY_FAILED: null,
    DELAY_REPAY_HPP_STARTED: null,
    DELAY_REPAY_HPP_RESPONSE_RECEIVED: null,
    DELAY_REPAY_HPP_AUTHORIZED: null,
    DELAY_REPAY_HPP_ABORTED: null,
    DELAY_REPAY_PAYMENT_RESET: null,
    DELAY_REPAY_RESET: null,
    DELAY_REPAY_CAPTCHA_COMPLETE: null,
    DELAY_REPAY_CAPTCHA_EXPIRED: null,
    DELAY_REPAY_CAPTCHA_VALIDATED: null,
    DELAY_REPAY_CAPTCHA_BYPASSED: null,
    DELAY_REPAY_CAPTCHA_FAILED: null,
    DELAY_REPAY_ADDRESS_UPDATED: null,
    DELAY_REPAY_BACS_VALIDATED: null,
    DELAY_REPAY_PAYMENT_PREFERENCES_LOADED: null,

    FAVOURITES_ADDED: null,
    FAVOURITES_REMOVED: null,
    FAVOURITES_LOADED: null,
    FAVOURITES_PHOTOCARD_UPDATED: null,
    FAVOURITES_DELIVERY_ADDED: null,
    FAVOURITES_DELIVERY_UPDATED: null,
    FAVOURITES_SEASON_EXPIRY_DATE_UPDATED: null,
    FAVOURITES_LAST_USED_DATE_UPDATED: null,

    DISRUPTION_ALERTS_LOAD_STARTED: null,
    DISRUPTION_ALERTS_LOAD_FINISHED: null,
    DISRUPTION_ALERTS_LOAD_FAILED: null,
    SERVICE_CHANGE_ALERTS_LOAD_STARTED: null,
    SERVICE_CHANGE_ALERTS_LOAD_FINISHED: null,
    SERVICE_CHANGE_ALERTS_LOAD_FAILED: null,
    DISRUPTION_ALERT_CREATED: null,
    DISRUPTION_ALERT_UPDATED: null,
    DISRUPTION_ALERT_DELETED: null,
    SERVICE_CHANGE_ALERT_DELETED: null,
    DISRUPTION_ALERT_MUTE_CREATED: null,
    DISRUPTION_ALERT_MUTE_UPDATED: null,
    DISRUPTION_ALERT_MUTE_DELETED: null,
    DISRUPTION_ALERTS_SEARCH_STARTED: null,
    DISRUPTION_ALERTS_SEARCH_FINISHED: null,
    DISRUPTION_ALERTS_SEARCH_FAILED: null,
    DISRUPTION_ALERTS_SEARCH_EARLIER_STARTED: null,
    DISRUPTION_ALERTS_SEARCH_EARLIER_FINISHED: null,
    DISRUPTION_ALERTS_SEARCH_LATER_STARTED: null,
    DISRUPTION_ALERTS_SEARCH_LATER_FINISHED: null,
    DISRUPTION_ALERTS_SERVICES_RESET: null,
    DISRUPTION_ALERTS_FETCH_BANK_HOLIDAYS_STARTED: null,
    DISRUPTION_ALERTS_FETCH_BANK_HOLIDAYS_FINISHED: null,
    DISRUPTION_ALERTS_FETCH_BANK_HOLIDAYS_FAILED: null,

    COMPENSATION_RESET: null,
    COMPENSATION_CLAIM_UPDATED: null,
    COMPENSATION_CLAIM_ABORTED: null,
    COMPENSATION_ROUTE_ADDED: null,
    COMPENSATION_ROUTE_REMOVED: null,
    COMPENSATION_TICKET_ADDED: null,
    COMPENSATION_TICKET_REMOVED: null,
    COMPENSATION_TRAVEL_WEEK_ADDED: null,
    COMPENSATION_TRAVEL_WEEK_REMOVED: null,
    COMPENSATION_TRAVEL_WEEK_UPDATED: null,
    COMPENSATION_UPLOAD_STARTING: null,
    COMPENSATION_UPLOAD_COMPLETE: null,
    COMPENSATION_UPLOAD_FAILED: null,
    COMPENSATION_UPLOAD_CANCELLED: null,
    COMPENSATION_WHITELIST_INITIALISED: null,
    COMPENSATION_WHITELIST_VALIDATED: null,
    COMPENSATION_SUBMITTED: null,
    COMPENSATION_AUTHORIZED: null,
    COMPENSATION_USER_ADDED: null,
    COMPENSATION_SMARTCARD_ADDED: null,
    AUTO_DR_CLAIMS_LOADING: null,
    AUTO_DR_CLAIMS_LOADED: null,
    AUTO_DR_CLAIMS_FAILED: null,
    AUTO_DR_CLAIM_SUBMIT_STARTED: null,
    AUTO_DR_CLAIM_SUBMITTED: null,
    AUTO_DR_CLAIM_SUBMIT_FAILED: null,
    AUTO_DR_CLAIM_SUBMIT_CANCELLED: null,
    AUTO_DR_CLAIM_AUTHORIZED: null,
    AUTO_DR_CLAIM_DISMISSED: null,
    AUTO_DR_CLAIM_SELECTED: null,
    AUTO_DR_CLAIM_DESELECTED: null,
    AUTO_DR_CLAIM_FORM_UPDATED: null,
    AUTO_DR_CLAIM_BACS_VALIDATED: null,

    FEATURE_TOGGLED: null,
    FEATURE_VARIANT_UPDATED: null,

    PRESELECT_CHEAPEST: null,
    UPDATE_DISPLAY_FILTERS: null,
    LAYOUT_SET_EMBEDDED: null,

    WIDGET_SEARCH_STATION_SELECT: null,
    WIDGET_SEARCH_STATION_SWITCH: null,
    WIDGET_SEARCH_CLICK: null,
    WIDGET_SEARCH_DAY_SELECT: null,

    PLUS_BUS_SELECT: null,
    FARES_EXPAND: null,

    EXTERNAL_LINK: null,

    JP_CHANGE_LAYOUT: null,
    JP_FARE_CLASS_FILTER_CLICK: null,
    JP_FARE_SELECTION_FILTER_CLICK: null,
    JP_TOC_SPECIFIC_FILTER_RENDERED: null,
    JP_TOC_SPECIFIC_FILTER_CLICK: null,
    JP_ALL_FARES_ACCORDION_CLICK: null,
    JP_CHECKOUT_WITH_SUGGESTED_PRODUCTS: null,
    JP_CHANGE_SEARCH_TYPE: null,

    TUTORIAL_TOGGLE: null,

    STATION_FINDER_SEARCH_STARTED: null,
    STATION_FINDER_SEARCH_COMPLETE: null,
    STATION_FINDER_SEARCH_FAILED: null,
    STATION_FINDER_STATIONS_CLEARED: null,
    STATION_FINDER_ERROR_CLEARED: null,
    STATION_FINDER_SET_EXPANDED: null,
    STATION_FINDER_STATION_SELECTED: null,
    STATION_FINDER_TICKET_OFFICE_LOADED: null,

    FAVOURITE_ADDED_TO_BASKET: null,
    REORDER_ADDED_TO_BASKET: null,

    RETURN_TRAVELCARD_CTA_CLICK: null,

    WIDGETS_RENDER_JP: null,
    WIDGETS_VIEW_RESULTS: null,

    VISA_CO_SETUP: null,
    VISA_CO_UPDATE_AMOUNT: null,
    VISA_CO_STORE_PAYMENT_CARD: null,
    VISA_CO_GET_CARD_DETAILS: null,
    VISA_CO_CARD_DETAILS_LOADED: null,
    VISA_CO_DELIVERY_ADDRESS_UPDATED: null,
    VISA_CO_STORED_PAYMENT_CARD_LOADED: null,

    GET_COLLECTION_STATIONS_STARTED: null,
    GET_COLLECTION_STATIONS_ENDED: null,
    GET_COLLECTION_STATIONS_FAILED: null,

    OPEN_GOLF_GET_TICKETS_STARTED: null,
    OPEN_GOLF_GET_TICKETS_ENDED: null,
    OPEN_GOLF_GET_TICKETS_FAILED: null,
    OPEN_GOLF_ADD_TRIP: null,

    FARE_HANDOFF_LOADING: null,
    FARE_HANDOFF_LOADED: null,
    FARE_HANDOFF_LOAD_FAILED: null,

    TRACKING_ENABLED: null,
    TRACKING_DISABLED: null,
    SHOW_FLEXI_WARNING_MODAL: null,
    FLEXI_WARNING_MODAL_ACKNOWLEDGEMENT_CHECKBOX_CHECKED: null,
    FLEXI_WARNING_MODAL_ACKNOWLEDGEMENT_CHECKBOX_UNCHECKED: null,
    FLEXI_WARNING_MODAL_CLOSE: null,
    FLEXI_WARNING_MODAL_CONTINUE: null,
    FLEXI_WARNING_MODAL_MORE_INFO_CLICKED: null,

    SEATING_AVAILABILITY_STARTED: null,
    SEATING_AVAILABILITY_LOADED: null,
    SEATING_AVAILABILITY_FAILED: null,

    TOGGLE_SEATFINDER: null,
    TOGGLE_STEP_FREE: null,
    TOGGLE_SEAT_AVAILABILITY: null,
    TOGGLE_JOURNEY_SUPPORT_MODAL: null,

    USER_OPTED_IN: null,
    USER_OPTED_OUT: null,
    SELECT_NOTIFICATION_PREFERENCE: null,
    SELECT_REPAYMENT_METHOD: null,
    AMEND_REPAYMENT_METHOD: null,
    AMEND_NOTIFICATION_PREFERENCE: null,
    AMEND_ADDRESS: null,

    USER_OCDR_SUBSCRIBE_SUCCESS: null,
    USER_OCDR_SUBSCRIBE_FAILURE: null,
    USER_OCDR_UNSUBSCRIBE_SUCCESS: null,
    USER_OCDR_UNSUBSCRIBE_FAILURE: null,
    USER_OCDR_UPDATE_SUBSCRIPTION_SUCCESS: null,
    USER_OCDR_UPDATE_SUBSCRIPTION_FAILURE: null,

    SET_IN_APP: null,

    SET_TIMETABLE_ALERTS_WIDGET_STATE: null,
    GET_TIMETABLE_ALERTS_WIDGET_STATE: null,
    ADD_TIMETABLE_ALERT: null,
    RESET_TIMETABLE_ALERTS: null,
    SAVE_REGULAR_JOURNEY_WITH_OCDR_FAV_JOURNEY: null,

    WEBCHAT_OPENED: null,

    BACK_FROM_PAYMENT_PAGE: null,
    ADD_ANOTHER_JOURNEY_ON_DELIVERY_PAGE: null,
    ADD_ANOTHER_JOURNEY_ON_PAYMENT_PAGE: null,
    ADD_ANOTHER_JOURNEY_ON_BASKET_MODAL: null,

    DELIVERY_SCREEN_BACK_NAVIGATION_TICKET_REMOVED: null,
    DELIVERY_SCREEN_BACK_NAVIGATION_TICKET_KEPT: null,

    SET_ACCESSIBILITY_PROFILE_FORM: null,
    AUTO_POPULATE_ACCESSIBILITY_PROFILE_FORM: null,
    RESET_ACCESSIBILITY_PROFILE_FORM: null,
    SET_ACCESSIBILITY_PROFILE_STATUS: null,
    SET_ACCESSIBILITY_PROFILE: null,
    SET_BOOKING_PA_STATUS: null,
    SET_TRAVEL_ASSIST: null,
    DELETE_TRAVEL_ASSIST: null,
    SET_PENDING_TRAVEL_ASSIST_REQUESTS: null,
    SET_PENDING_TRAVEL_ASSIST_REQUEST_ENABLED: null,
    CLEAR_PENDING_TRAVEL_ASSIST_REQUESTS: null,
    RESET_TRAVEL_ASSIST: null,
    SET_IS_EDIT_PA_MODE_ENABLED: null,
    SET_EDIT_PA_SECTION: null,
    USE_ACCESSIBILITY_PROFILE: null,
    RESET_OUTWARD_JOURNEY: null,
    RESET_RETURN_JOURNEY: null,
    SET_BOOKING_PA_ENTER_ACCESSIBILITY_PROFILE_STEP: null,
    SET_SHOW_BACK_TO_SEARCH_RESULTS_BUTTON: null,

    ADD_ORDER_TRIP_ID_TO_PASSENGER_ASSIST_REQUEST: null,


    SET_ACCESSIBILITY_PROFILE_STEP: null,
    SET_NEXT_ACCESSIBILITY_PROFILE_STEP: null,
    SET_PREV_ACCESSIBILITY_PROFILE_STEP: null,

    SET_BOOKING_PA_STEP: null,
    SET_NEXT_BOOKING_PA_STEP: null,
    SET_PREV_BOOKING_PA_STEP: null,

    FETCH_CHILD_SMARTCARD_REPLACEMENT_STARTED: null,
    FETCH_CHILD_SMARTCARD_REPLACEMENT_SUCCESS: null,
    FETCH_CHILD_SMARTCARD_REPLACEMENT_FAILED: null,
    FETCH_CHILD_SMARTCARD_REPLACEMENT_FINISHED: null,

    REQUEST_CHILD_SMARTCARD_REPLACEMENT_STARTED: null,
    REQUEST_CHILD_SMARTCARD_REPLACEMENT_SUCCESS: null,
    REQUEST_CHILD_SMARTCARD_REPLACEMENT_FAILED: null,
    REQUEST_CHILD_SMARTCARD_REPLACEMENT_FINISHED: null,

    GET_ACCESSIBILITY_PROFILE_STARTED: null,
    GET_ACCESSIBILITY_PROFILE_LOADED: null,
    GET_ACCESSIBILITY_PROFILE_FAILED: null,
    GET_ACCESSIBILITY_PROFILE_FINISHED: null,

    CREATE_ACCESSIBILITY_PROFILE_STARTED: null,
    CREATE_ACCESSIBILITY_PROFILE_LOADED: null,
    CREATE_ACCESSIBILITY_PROFILE_FAILED: null,
    CREATE_ACCESSIBILITY_PROFILE_FINISHED: null,

    DELETE_ACCESSIBILITY_PROFILE_STARTED: null,
    DELETE_ACCESSIBILITY_PROFILE_SUCCESS: null,
    DELETE_ACCESSIBILITY_PROFILE_FAILED: null,
    DELETE_ACCESSIBILITY_PROFILE_FINISHED: null,

    UPDATE_ACCESSIBILITY_PROFILE_STARTED: null,
    UPDATE_ACCESSIBILITY_PROFILE_LOADED: null,
    UPDATE_ACCESSIBILITY_PROFILE_FAILED: null,
    UPDATE_ACCESSIBILITY_PROFILE_FINISHED: null,

    GET_PREVIOUS_JOURNEYS_STARTED: null,
    GET_PREVIOUS_JOURNEYS_SUCCESS: null,
    GET_PREVIOUS_JOURNEYS_FAILED: null,
    GET_PREVIOUS_JOURNEYS_FINISHED: null,

    GET_ASSISTED_TRAVEL_LOCATION_STARTED: null,
    GET_ASSISTED_TRAVEL_LOCATION_SUCCESS: null,
    GET_ASSISTED_TRAVEL_LOCATION_FAILED: null,
    GET_ASSISTED_TRAVEL_LOCATION_FINISHED: null,

    BOOK_ASSIST_STARTED: null,
    BOOK_ASSIST_SUCCESS: null,
    BOOK_ASSIST_FAILED: null,
    BOOK_ASSIST_FINISHED: null,

    BOOK_MANY_ASSISTS_STARTED: null,
    BOOK_MANY_ASSISTS_SUCCESS: null,
    BOOK_MANY_ASSISTS_FAILED: null,
    BOOK_MANY_ASSISTS_FINISHED: null,

    GET_ASSISTED_BOOKING_STARTED: null,
    GET_ASSISTED_BOOKING_SUCCESS: null,
    GET_ASSISTED_BOOKING_FAILED: null,
    GET_ASSISTED_BOOKING_FINISHED: null,

    GET_ASSISTED_BOOKINGS_STARTED: null,
    GET_ASSISTED_BOOKINGS_SUCCESS: null,
    GET_ASSISTED_BOOKINGS_FAILED: null,
    GET_ASSISTED_BOOKINGS_FINISHED: null,

    SET_PASSENGER_ASSIST_WIDGET_TOGGLED: null,

    CANCEL_ASSISTED_BOOKING_STARTED: null,
    CANCEL_ASSISTED_BOOKING_SUCCESS: null,
    CANCEL_ASSISTED_BOOKING_FAILED: null,
    CANCEL_ASSISTED_BOOKING_FINISHED: null,

    EDIT_ASSISTED_BOOKING_STARTED: null,
    EDIT_ASSISTED_BOOKING_SUCCESS: null,
    EDIT_ASSISTED_BOOKING_FAILED: null,
    EDIT_ASSISTED_BOOKING_FINISHED: null,

    FAMILY_VERIFICATION_STARTED: null,
    FAMILY_VERIFICATION_VERIFIED: null,
    FAMILY_VERIFICATION_FAILED: null,
    FAMILY_VERIFICATION_ALLOWANCE_EXCEEDED: null,
    FAMILY_VERIFICATION_RESET: null,

    START_RESERVATION_FLOW: null,
    CANCEL_RESERVATION_FLOW: null,
    RESERVATION_COMPLETED: null,

    ADD_BIKE_RESERVATION: null,
    REMOVE_BIKE_RESERVATION: null,
    ADD_SEAT_RESERVATION: null,
    REMOVE_SEAT_RESERVATION: null,

    CREATE_RESERVATION_STARTED: null,
    CREATE_RESERVATION_LOADED: null,
    CREATE_RESERVATION_FINISHED: null,
    CREATE_RESERVATION_FAILED: null,

    AMEND_RESERVATION_STARTED: null,
    AMEND_RESERVATION_LOADED: null,
    AMEND_RESERVATION_FINISHED: null,
    AMEND_RESERVATION_FAILED: null,

    GET_RESERVATION_STARTED: null,
    GET_RESERVATION_LOADED: null,
    GET_RESERVATION_FINISHED: null,
    GET_RESERVATION_FAILED: null,
    CLEAR_RESERVATION_STORE: null,

    RESERVATION_WIDGET_TOGGLED: null,

    GET_ORDER_CHARITY_OPTIONS_STARTED: null,
    GET_ORDER_CHARITY_OPTIONS_SUCCESS: null,
    GET_ORDER_CHARITY_OPTIONS_FAILED: null,
    GET_ORDER_CHARITY_OPTIONS_FINISHED: null,

    SET_ORDER_CHARITY_OPTIONS_STARTED: null,
    SET_ORDER_CHARITY_OPTIONS_SUCCESS: null,
    SET_ORDER_CHARITY_OPTIONS_FAILED: null,
    SET_ORDER_CHARITY_OPTIONS_FINISHED: null,

    DELETE_ORDER_CHARITY_OPTIONS_STARTED: null,
    DELETE_ORDER_CHARITY_OPTIONS_SUCCESS: null,
    DELETE_ORDER_CHARITY_OPTIONS_FAILED: null,
    DELETE_ORDER_CHARITY_OPTIONS_FINISHED: null,

    CANCEL_RESERVATION_STARTED: null,
    CANCEL_RESERVATION_SUCCESS: null,
    CANCEL_RESERVATION_FAILED: null,
    CANCEL_RESERVATION_FINISHED: null,
    CLEAR_CANCEL_RESERVATION_STATUS: null,

    SET_RESERVATION_REQUEST_PASSENGERS: null,
    SET_RESERVATION_REQUEST_BIKES: null,

    SET_RESERVATION_BIKES_COUNT: null,

    CLEAR_RESERVATION_REQUEST_STORE: null,

    GET_RESERVATIONS_AVAILABILITY_STARTED: null,
    GET_RESERVATIONS_AVAILABILITY_SUCCESS: null,
    GET_RESERVATIONS_AVAILABILITY_FAILED: null,
    GET_RESERVATIONS_AVAILABILITY_FINISHED: null,

    SET_RESERVATION_REQUEST_OUTBOUND_SERVICE: null,
    SET_RESERVATION_REQUEST_INBOUND_SERVICE: null,
    SET_RESERVATION_REQUEST_OUTBOUND_FARE: null,
    SET_RESERVATION_REQUEST_INBOUND_FARE: null,

    SET_RESERVATION_PAGINATION: null,

    SET_RESERVATION_REQUEST_SEATS: null,
});

export const RecentStationsTypes = keyMirror({
    SEASON: null,
    POINT: null,
    SMARTCARD: null,
    SMARTCARDSEASON: null,
    DAYSAVE: null,
    DELAY_REPAY: null,
});

export const StationTypes = {
    ORIGIN: 'origin',
    DESTINATION: 'destination',
    TICKET_ORIGIN: 'ticketOrigin',
    TICKET_DESTINATION: 'ticketDestination',
    VIAAVOID: 'viaAvoid',
    VIA: 'via',
    AVOID: 'avoid',
};

export const DaySaveStationTypes = {
    ORIGIN: 'DaySaveOrigin',
};

export const SmartcardStationTypes = {
    ORIGIN: 'smartcardOrigin',
    DESTINATION: 'smartcardDestination',
    VIAAVOID: 'smartcardViaAvoid',
};

export const SeasonStationTypes = {
    ORIGIN: 'seasonOrigin',
    DESTINATION: 'seasonDestination',
};

export const SmartcardSeasonStationTypes = {
    ORIGIN: 'SmartcardSeasonOrigin',
    DESTINATION: 'SmartcardSeasonDestination',
};

export const DelayRepayStationTypes = {
    ORIGIN: 'delayRepayOrigin',
    DESTINATION: 'delayRepayDestination',
    VIAAVOID: 'delayRepayViaAvoid',
    TICKETORIGIN: 'delayRepayOrigin',
    TICKETDESTINATION: 'delayRepayDestination'
};

export const TimeTypes = {
    ARRIVE: 'Arrive',
    DEPART: 'Depart',
};

export const TimeDirections = {
    EARLIER: 'earlier',
    LATER: 'later',
};

export const JourneyStatus = {
    SUCCESSFUL: 'successful',
    BROKEN: 'broken',
    REPAIRED: 'repaired',
};

export const AdjustedTimeConfidence = {
    UNCERTAIN: 'Uncertain',
};

export const JourneyDirections = {
    OUTWARD: 'outward',
    INWARD: 'inward',
};

export const PlusBusDirections = {
    OUTWARD: 'outward',
    RETURN: 'return',
};

export const SearchTypes = {
    CHEAPEST: 'cheapest',
    FASTEST: 'fastest',
};

export const FareClasses = {
    STANDARD: 'standard',
    FIRST_CLASS: 'first-class',
    CARNET: 'carnet',
    ALL: 'all',
};

export const NRELinkFareClasses = {
    STANDARD: 'Standard',
    FIRST: 'First',
};

export const BasketItemTypes = {
    SINGLE_OUTWARD: 'outwardSingle',
    SINGLE_INWARD: 'inboundSingle',
    RETURN: 'return',
};

export const FareCategories = {
    ADVANCE: 'Advance',
    OFF_PEAK: 'OffPeak',
    ANYTIME: 'Anytime',
};

export const FareFilterSelections = keyMirror({
    CHEAPEST: null,
    FASTEST: null,
    FIRST_CLASS: null,
});

export const SmartCarnetFilterTypes = {
    ROUTE: 'route',
    SERVICE: 'service'
};

export const SmartCarnetFiltersService = keyMirror({
    OFF_PEAK: null,
    PEAK: null,
});

export const SmartCarnetFiltersRoute = keyMirror({
    ANY_PERMITTED: null,
    BRAND_ONLY: null
});

export const GridPages = {
    SERVICES: 'services-grid',
};

export const PointStages = {
    INIT: 'point-init',
    SEARCH: 'point-search',
    RESULTS: 'point-results',
    SEARCH_RESULTS: 'point-search-results',
    CHOOSE_OUTWARD: 'point-choose-out',
};

export const SeasonStages = {
    INIT: 'season-init',
    SEARCH: 'season-search',
    RESULTS: 'season-results',
    DETAILS: 'season-details',
};

export const OtherTicketStages = {
    SEARCH: 'other-search',
};

export const DaySaveStages = {
    SEARCH: 'daysave-search',
    RESULTS: 'daysave-results',
};

export const RoversRangersStages = {
    SEARCH: 'roversrangers-search',
    RESULTS: 'roversrangers-results',
};

export const SmartCarnetStages = {
    SEARCH: 'smartcarnet-search',
    RESULTS: 'smartcarnet-results'
};

export const CheckoutStages = {
    DELIVERY: 'delivery',
    PAYMENT: 'payment',
    PAYMENT_AMAZON_PAY: 'payment-amazonpay',
    PAYMENT_CARD_HOSTED: 'payment-card-hosted',
    PAYMENT_CARD_HOSTED_BRAINTREE: 'payment-card-hosted-braintree',
    PAYMENT_CONFIRMATION: 'payment-confirmation',
    AMAZON_PAY_MFA_SUCCESS: 'amazonpay-mfa-success',
    AMAZON_PAY_MFA_FAILURE: 'amazonpay-mfa-failure',
};

export const AccountPages = {
    ACCOUNT_DETAILS: 'account',
    ACCOUNT_ADDRESSES: 'account-addresses',
    ACCOUNT_PREFERENCE_CENTRE: 'account-preferences',
    ACCOUNT_PHOTOCARDS_RAILCARDS: 'account-photocards-railcards',
    ACCOUNT_PAYMENT: 'account-payment',
    ACCOUNT_ORDERS_REFUNDS: 'account-ordersrefunds',
    ACCOUNT_ORDER_DETAILS: 'account-orderdetails',
    ACCOUNT_REFUND_DETAILS: 'account-refunddetails',
    ACCOUNT_AUTO_DELAY_REPAY: 'auto-delay-repay',
    ACCOUNT_AMEND_DETAILS: 'account-amenddetails',
    ACCOUNT_AMEND_SEARCH: 'account-amendsearch',
    ACCOUNT_AMEND_CHECKOUT: 'account-amendcheckout',
    ACCOUNT_STICKETS: 'account-stickets',
    ACCOUNT_ETICKETS: 'account-etickets',
    ACCOUNT_DISRUPTION_ALERTS: 'account-disruption-alerts',
    ACCOUNT_LINK_ORDER: 'account-linkorder',
    ACCOUNT_SMART_CARNET: 'account-smart-carnet',
    ACCOUNT_CONFIRM_SMARTCARD_REPLACEMENT: 'account-confirm-smartcard-replacement',
    ACCOUNT_RESERVATIONS: 'account-reservations',
    SMARTCARD_APPLY: 'smartcard-apply',
    SMARTCARD_TICKETS: 'smartcard-tickets',
    SMARTCARD_HISTORY: 'smartcard-history',
    SMARTCARD_KEYGO: 'smartcard-keygo',
    SMARTCARD_KEYGO_HISTORY: 'smartcard-keygo-history',
    SMARTCARD_REPLACEMENT: 'smartcard-replacement',
    SMARTCARD_TRANSFER: 'smartcard-transfer',
    SMARTCARD_TRANSFER_RESULTS: 'smartcard-transfer-results',
    SMARTCARD_TRANSFER_CONFIRMATION: 'smartcard-transfer-confirmation',
    SMARTCARD_LINK: 'smartcard-link',
    SMARTCARD_LINK_CONFIRMATION: 'smartcard-link-confirmation',
    EVOUCHERS: 'evouchers',
    AUTO_DELAY_REPAY: 'auto-dr-claims',
    ONE_CLICK_DELAY_REPAY: 'one-click-delay-repay',
    FLEXI: 'flexi',
    BOOK_PASSENGER_ASSIST: 'book-passenger-assist',
    VIEW_BOOKED_ASSISTANCE: 'view-booked-assistance',
    ACCESSIBILITY_PROFILE: 'accessibility-profile',
};

export const PortalClaims = {
    MY_CLAIMS: 'my-claims',
};

export const DisruptionAlertsPages = {
    MUTE: 'disruption-alerts-mute',
    DELETE: 'timetable-change-delete'
};

export const SmartcardPages = {
    SELF_REGISTERED: 'smartregister',
};

export const AccountPagesForceLoginInsteadOfRedirect = [
    AccountPages.ACCOUNT_STICKETS,
    AccountPages.ACCOUNT_ETICKETS,
    AccountPages.ACCOUNT_LINK_ORDER,
    AccountPages.ACCOUNT_PREFERENCE_CENTRE,
    AccountPages.ACCOUNT_DISRUPTION_ALERTS,
];

export const Tutorials = {
    JP_GRID: 'jp-grid',
    JP_LIST: 'jp-list',
    SEASONS: 'seasons',
    STATION_FINDER: 'station-finder',
    PREFERENCE_CENTRE: 'preference-centre',
    SMARTCARD: 'smartcard',
    RAILCARD: 'railcard',
};

export const JPListTutorialStages = {
    INTRO: 'intro',
    TABS: 'tabs',
    LIST_VIEW: 'list-view',
    GRID_VIEW: 'grid-view',
    TOC_FILTER: 'toc-filter',
    SELECT_SERVICE: 'select-service',
    SERVICE_INFO: 'service-info',
    SELECT_FARE: 'select-fare',
    TICKET_DETAILS: 'ticket-details',
    RETURN_SERVICE: 'return-service',
    PREFERENCES: 'preferences',
};

export const JPGridTutorialStages = {
    INTRO: 'intro',
    TABS: 'tabs',
    GRID_VIEW: 'grid-view',
    LIST_VIEW: 'list-view',
    TOC_FILTER: 'toc-filter',
    SERVICE_CAROUSEL: 'service-carousel',
    SERVICE_INFO: 'service-info',
    TICKET_CATEGORIES: 'ticket-categories',
    TICKET_DETAILS: 'ticket-details',
    PREFERENCES: 'preferences',
};

export const SeasonsTutorialStages = {
    INTRO: 'intro',
    FILTERS: 'filters',
    COMPARISON: 'comparison',
};

export const StationFinderTutorialStages = {
    INTRO: 'intro',
    ORIGIN_DESTINATION: 'origin-destination',
};

export const CONSENTS = {
    PHONE: 'phone',
    EMAIL_MARKETING: 'Email_Marketing',
    PUSH_MARKETING: 'Push_Marketing',
    SMS_Marketing: 'SMS_Marketing',
    OVER_16: 'over_16',
    UNDER_16: 'under_16',
    I_CONFIRM_16_YEARS_OLD: 'i_confirm_i_am_16_years_old_or_older',
    PERMISSIONS: 'permissions',
    SINGLE_CHOICE_PREFERENCE: 'single-choice-preference',
};

export const SmartcardTutorial = {
    INTRO: 'intro',
};

export const RailcardTutorial = {
    INTRO: 'intro',
};

export const NREPages = {
    ORDER_LANDING: 'order-landing',
};

export const LoginPages = {
    RESET_PASSWORD: 'reset-password',
    SET_PASSWORD_AND_PREFERENCES: 'set-password-and-preferences',
};

export const NewsletterPages = {
    UNSUBSCRIBE: 'newsletter-unsubscribe',
};

export const InAppPages = {
    LOGIN: 'in-app-login',
    ACCOUNT: 'in-app-account-menu',
    ACCOUNT_ORDERS_REFUNDS: 'in-app-account-orders',
    ONE_CLICK_DELAY_REPAY: 'in-app-one-click-delay-repay',
    AUTO_DELAY_REPAY: 'in-app-auto-delay-repay',
    REDIRECT: 'in-app-redirect',
    REGISTER: 'in-app-register',
    REGISTER_SMARTCARD: 'in-app-register-smartcard',
    SEARCH: 'in-app-search',
    SEASON_SEARCH: 'in-app-season-tickets',
    LOGOUT: 'in-app-logout',
    RESULTS: 'in-app-results',
    SEASON_RESULTS: 'in-app-season-results',
};

export const WidgetAuthPages = {
    LOGIN: 'widget-auth-login',
    REGISTER: 'widget-auth-register',
    LOGOUT: 'widget-auth-logout',
};

export const HandOffPages = {
    FARE: 'hand-off-fare'
};

export const PromotionPages = {
    PROMOTION: 'promotion',
    APPLY_PROMOTION: 'apply-promotion',
    TOC_FAMILY: 'toc-family',
    TOC_FAMILY_VERIFY: 'toc-family-verify',
};

export const OtherPages = {
    PAYMENT_LANDING: 'order-payment',
};

export const SearchWidgetPages = {
    IFRAME: 'search-widget-iframe',
};

export const DelayRepayPages = {
    CUSTOMER: 'delayrepay-customer',
    CLAIMS: 'delayrepay-claims',
    PAYMENT: 'delayrepay-payment',
    CONFIRM: 'delayrepay-confirm',
};

export const AutoDelayRepayPages = {
    SUBSCRIPTION: 'auto-delayrepay-subscription',
};

export const DelayRepayClaimType = {
    DEFAULT: 'delay-repay',
    SEASON_COMPENSATION: 'season-ticket-compensation',
    NON_SEASON_COMPENSATION: 'daily-ticket-compensation',
};

export const CompensationPages = {
    DETAILS: 'compensation-details',
    SEASON: 'compensation-season',
    PRE_APPROVED: 'compensation-pre-approved',
    NON_SEASON: 'compensation-non-season',
};

export const CompensationClaimType = {
    WHITELIST: 'whitelist',
    SEASON: 'season',
    NON_SEASON: 'nonSeason',
};

export const CompensationTicket = {
    // season
    STANDARD: 'season-standard-class',
    FIRST_CLASS: 'season-first-class',
    TRAVELCARD: 'season-travelcard',
    SEASON_OYSTER: 'season-oyster',
    SMART_KEY: 'contactless-key',
    SMART_PAYGO: 'contactless-paygo',
    SMART_OTHER: 'contactless-other',

    // non-season
    SINGLE: 'single',
    RETURN: 'return',
    CARNET: 'carnet',
    FREEDOM_PASS: 'freedom-pass',
    CONTACTLESS_BANK: 'contactless-other',
    OYSTER_PAYG: 'contactless-paygo',
    CONTACTLESS_KEY: 'contactless-key',
};

export const CompensationPurchaseLocations = {
    STATION: 'ticket-office',
    WEBSITE: 'online',
    OTHER: 'other',
};

export const CompensationEvidence = {
    TICKET_IMAGE: 'ticket-image',
    TICKET_RECEIPT: 'receipt',
    TICKET_MIXTURE: 'ticket-mixture',
    BANK_STATEMENT: 'bank-statement',
    JOURNEY_HISTORY: 'journey-history',
    FREEDOM_PASS_IMAGE: 'freedom-pass-image',
    OTHER: 'further-information',
    NONE: 'no-evidence',
};

export const DelayRepayTicket = {
    SEASON_ANNUAL: 'season-annual',
    SEASON_SIX_MONTHLY: 'season-quarterly',
    SEASON_QUARTERLY: 'season-six-monthly',
    SEASON_MONTHLY: 'season-monthly',
    SEASON_WEEKLY: 'season-weekly',
    SEASON_OTHER: 'season-other',
    SEASON_OYSTER: 'season-oyster',
    SINGLE: 'single',
    RETURN: 'return',
    ETICKET_SINGLE: 'selfprint-single',
    ETICKET_RETURN: 'selfprint-return',
    SMART_KEY: 'contactless-key',
    SMART_PAYGO: 'contactless-paygo',
    SMART_OTHER: 'contactless-other',
    ADVANCE: 'advance',
    ANYTIME_DAY_RETURN: 'anytime-day-return',
    ANYTIME_DAY_SINGLE: 'anytime-day-single',
    ANYTIME_RETURN: 'anytime-return',
    ANYTIME_SINGLE: 'anytime-single',
    OFFPEAK_DAY_RETURN: 'offpeak-day-return',
    OFFPEAK_DAY_SINGLE: 'offpeak-day-single',
    OFFPEAK_RETURN: 'offpeak-return',
    OFFPEAK_SINGLE: 'offpeak-single',
    ROVER_RANGER: 'rover-ranger',
};

export const CompensationLevel = {
    NONE: 'OFF_ROUTE',
    LEVEL1: 'QUALIFIES_MONTHLY_CAP',
    LEVEL2: 'QUALIFIES_WEEKLY_CAP',
};

export const DelayRepayTicketClass = {
    STANDARD: 'standard-class',
    FIRST_CLASS: 'first-class',
};

export const DelayRepayClaimReason = {
    DELAYED_DEPARTURE: 'Delayed Departure',
    DELAYED_ON_ROUTE: 'Delayed on Route',
    TRAIN_CANCELLED: 'Train Cancelled',
    TRAIN_DIVERTED: 'Train Diverted',
    TRAIN_SHORT_FORMED: 'Train short formed',
    MISSED_CONNECTION: 'Missed Connection',
    RESUBMITTED_CLAIM: 'Resubmitted Claim',
    ABANDONED_JOURNEY: 'Abandoned Journey',
    STRIKE_ACTION: 'Strike Action',
    OTHER: 'Other',
};

export const Widgets = {
    OPEN_GOLF_FIND_TICKETS: 'open-golf-find-tickets-widget',
    OPEN_GOLF_TIMETABLE: 'open-golf-timetable-widget',
    OPEN_GOLF_TICKET_SELECTION: 'open-golf-ticket-selection',
    REFUND_WIDGET: 'refund-widget',
};

export const DelayRepayPaymentMethod = {
    BACS: 'bacs',
    EVOUCHER: 'e-vouchers',
    PAYPAL: 'paypal',
    CARD: 'credit/debit card',
    AMAZON: 'amazon-incentives',
    VOUCHER: 'cashable voucher',
    CHEQUE: 'cheque',
    CHARITY: 'rail-charity',
};

export const DelayRepayBankPeriod = {
    MONTHLY: 'monthly',
    QUARTERLY: 'quarterly',
    ANNUALLY: 'annually',
    NONE: 'do not bank',
};

export const ReservableStates = {
    COMPULSORY: 'Compulsory',
    BICYCLES: 'BicyclesEssential',
    RECOMMENDED: 'Recommended',
    POSSIBLE: 'Possible',
    NO: 'No',
};

export const SeatingPrefs = {
    NONE: 'NONE',
    FORWARDS: 'FACE',
    BACKWARDS: 'BACK',
    AISLE: 'AISL',
    WINDOW: 'WIND',
    INDIVIDUAL: 'INDL',
    AIRLINE: 'AIRL',
    TABLE: 'TABL',
    QUIET_COACH: 'QUIE',
    NEAR_TOILET: 'NRWC',
    POWER_SOCKET: 'POWE',
    NEAR_LUGGAGE: 'LUGG',
};

export const SeatingPrefNames = {
    [SeatingPrefs.FORWARDS]: 'booking.seating.direction.forwards',
    [SeatingPrefs.BACKWARDS]: 'booking.seating.direction.backwards',
    [SeatingPrefs.AISLE]: 'booking.seating.position.aisle',
    [SeatingPrefs.WINDOW]: 'booking.seating.position.window',
    [SeatingPrefs.INDIVIDUAL]: 'booking.seating.position.individual',
    [SeatingPrefs.AIRLINE]: 'booking.seating.seatType.airline',
    [SeatingPrefs.TABLE]: 'booking.seating.seatType.table',
    [SeatingPrefs.QUIET_COACH]: 'booking.seating.features.quietCoach',
    [SeatingPrefs.NEAR_TOILET]: 'booking.seating.features.nearToilets',
    [SeatingPrefs.POWER_SOCKET]: 'booking.seating.features.powerSocket',
    [SeatingPrefs.NEAR_LUGGAGE]: 'booking.seating.features.nearLuggageRack',
};

export const OperatorColors = {
    DEFAULT: '#10069f',
    TL: '#461e78', // Thameslink
    GN: '#461e78', // Great Northern
    VT: '#1f4555', // Virgin Trains
    GR: '#cc0000', // Virgin Trains East Coast
    LM: '#25252D', // London Midland
    XC: '#443135', // CrossCountry
    SE: '#1D1951', // SouthEastern
    TP: '#ed037c', // First Transpennine Express
    GX: '#cc0000', // Gatwick Express
    SN: '#2f9771',
    GW: '#001e67',
    SW: '#f89520',
    NR: '#7d4199',
    GE: '#fe0000',
};

export const StopPatterns = {
    PASSING: 'Passing',
    NORMAL: 'Normal',
    PICK_UP: 'PickUpOnly',
    SET_DOWN: 'SetDownOnly',
};

export const FulfilmentType = {
    E_TICKET: '00006',
    PRINT_AT_HOME: '00003',
    COLLECTION: '00005',
    POSTAL: '00009',
    SMARTCARD: '00001',
    S_TICKET: '00007'
};

export const STicketStatus = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
};

// we need to declare different icons soon
export const PostalDeliveryType = {
    FIRST_CLASS: '1st-class-mail',
    ROYAL_SIGNED: '1st-class-mail',
    ROYAL_SPECIAL: '1st-class-mail',
};

export const SmartcardErrorNonBlocking = {
    NOT_LOGGED: 'NotLoggedInError',
    NO_SMARTCARD: 'NoSmartcardError',
    APP_COLLECTION_ONLY: 'AppCollectionOnlyError',
};

export const SmartCardErrorBlockingForLoggedIn = {
    INVALID_KEYGO: 'InvalidKeygoError',
    TOO_MANY_ADULT_TICKETS_SMARTCARD: 'TooManyAdultTicketsInBasketError',
    TOO_MANY_CHILD_TICKETS_SMARTCARD: "TooManyChildTicketsInBasketError",
    NOT_ENOUGH_ACTIVE_SMARTCARDS_ERROR: "NotEnoughActiveSmartcardsError",
    TICKET_WITH_INVALID_AGE_FOR_CHILD_SMARTCARD_ERROR: 'TicketWithInvalidAgeForChildSmartcardError',
    TICKET_WITH_EXPIRED_SMARTCARD_ERROR: 'TicketWithExpiredSmartcardError',
};

export const SmartcardErrorBlocking = {
    PENDING_SMARTCARD: 'PendingSmartcardError',
    PENDING_ACTIONLIST: 'PendingActionlistError',
    TOO_MANY_TICKETS_SMARTCARD: 'TooManyTicketsOnSmartcardError',
    CANT_DELIVER_IN_TIME: 'SmartcardCantBeDeliveredInTimeError',
    EXPIRED_SMARTCARD: 'ExpiredSmartcardError',
    INVALID_SMARTCARD: 'InvalidSmartcardStatusError',
    NOT_ENOUGH_TIME: 'NotEnoughTimeToActionlistTicketError',
    NOT_CORRECT_AGE: 'NotCorrectAgeForFareError',
    PRE_ENCODE_ERROR: 'DisabledPreEncodeError',
    SMART_CARNET_EXCEEDED_PASSES: 'SmartCarnetExceededNumberOfPassesError',
    INVALID_CARNET_TICKET_TYPE: 'InvalidCarnetTicketTypeError'
};

export const SmartcardSelfRegistrationStatuses = {
    LINK_SMARTCARD: 'Link',
    ONLY_REPLACEMENT: 'Replacement',
    NEW_SMARTCARD: 'New',
    NOT_POSSIBLE: 'Denied',
    COMPLETE: 'Complete',
};

export const SmartcardServiceErrors = {
    SERVICE_NOT_AVAILABLE: 'SmartcardServiceNotAvailableError',
    DECODING_ERROR: 'DecodingError',
};

export const TransitModes = {
    TRAIN: 'Train',
    METRO: 'Metro',
    BUS: 'Bus',
    REPLACEMENT_BUS: 'ReplacementBus',
    TRAM: 'Tram',
    FERRY: 'Ferry',
    TAXI: 'Taxi',
    WALK: 'Walk',
    OTHER: 'Other',
};

export const DurationTypes = {
    WEEKLY: 'weekly',
    FOUR_WEEKLY: 'fourWeekly',
    MONTHLY: 'monthly',
    QUARTERLY: 'quarterly',
    SIX_MONTHLY: 'sixMonthly',
    ANNUAL: 'annual',
    CUSTOM: 'custom',
};

export const DurationPeriods = {
    [DurationTypes.WEEKLY]: [0, 7],
    [DurationTypes.FOUR_WEEKLY]: [0, 28],
    [DurationTypes.MONTHLY]: [1, 0],
    [DurationTypes.QUARTERLY]: [3, 0],
    [DurationTypes.SIX_MONTHLY]: [6, 0],
    [DurationTypes.ANNUAL]: [12, 0],
};

export const SeasonCustomRange = {
    MIN: 'P1M1D',
    MAX: 'P10M12D',
};

export const Duration = {
    P7D: 'Weekly',
    P1M: 'Monthly',
    P1Y: 'Annual',
    P1Y1D: 'Annual', // leap year??
};

export const JourneyPlannerLayout = keyMirror({
    GRID: null,
    GRID_2: null,
    LIST: null,
});

export const ServicesPerLayout = {
    [JourneyPlannerLayout.GRID]: 3,
    [JourneyPlannerLayout.GRID_2]: 3,
    [JourneyPlannerLayout.LIST]: 5,
};

export const ListSteps = {
    OUTWARD_SERVICE: 'outward-service',
    OUTWARD_FARE: 'outward-fare',
    INWARD_SERVICE: 'inward-service',
    INWARD_FARE: 'inward-fare',
};

export const BreakPoints = {
    DESKTOP_WIDTH_XL: 1701,
    DESKTOP_WIDTH_L: 1200,
    DESKTOP_WIDTH: 992,
    TABLET_PORTRAIT_WIDTH: 767,
    MOBILE_WIDTH: 508,
    DROPDOWN_MEDIUM_HEIGHT: 930,
    DROPDOWN_SMALL_HEIGHT: 750,
};

export const API_ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const API_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const API_KEYGO_FORMAT = "YYYY-MM-DDTHH:mm:ss[Z]";

export const GlobalModals = keyMirror({
    REGISTER: null,
    REGISTER_SMARTCARD: null,
    LOGIN: null,
    ERROR: null,
    CONFIRM: null,
    INFO: null,
    BASKET: null,
    BASKET_EXPIRED: null,
    FORGOT_PASSWORD: null,
    LOGGED_OUT: null,
    LOGOUT_WARNING: null,
    NRE: null,
    ORDER_STATE_ERROR: null,
    SYNC_EMAIL_AMAZON_LOGIN: null,
    PROMPT_PASSWORD_CHANGE: null,
    INTEROP_ERROR: null,
    BOOK_PASSENGER_ASSIST: null,
    CHILD_SMART_CARD_EXPIRATION: null,
});

export const GenericModals = keyMirror({
    FARE_INFO: null,
    FARE_CATEGORY_INFO: null,
    SERVICE_INFO: null,
    JOURNEY_DETAILS_FORM: null,
    STATION_FINDER: null,
    TRAVELCARD_FARES: null,
    RAILCARD1617: null,
    TRAVEL_VIA_AVOID: null,
    PASSENGERS_RAILCARDS: null,
    OPEN_RETURN: null,
    SMARTCARD_TUTORIAL: null,
    PLUS_BUS: null,
    OYSTER: null,
    SEATING_PREFERENCES: null,
    DISRUPTION_ALERT: null,
    DELETE_ACCOUNT: null,
});

export const Validation = {
    // validated against 2.5 million postcodes -  https://gist.github.com/simonflk/a5bf43bac48791db5563
    postcode: /^([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?)\s*(\d[ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/,
    countryCode: /^[A-Z]{3}$/,
    telephone: /^\+?(\d+[-\s]*)+$/,
    cv2: /^\d{3,4}$/,
    sortCode: /^\s*\d\d(?:-|\s+)?\d\d(?:-|\s+)?\d\d\s*$/,
    accountNumber: /^\d{8}$/,
    cardHolderName: /\S+\s+\S+/,
    photocardHolder: /^(?=.{1,40}$)[A-Za-zÀ-ÿ]+(?:[-'` ][A-Za-zÀ-ÿ]+)*$/,
    delayRepayTicketNumber: /^\d{5}$/,
    issueNumber: /^[\dA-Za-z-]{1,35}$/,
    keySmartcardNumber: /^633\d{3}[ -]?\d{4}[ -]?\d{4}[ -]?\d{4}$/,
    oysterNumber: /^\d{10}\s?\d{2}$/,
    lettersAndSpaces: /^[a-zA-Z' -]+$/,
};

export const SmartcardStatus = keyMirror({
    AWAITING_PRODUCT: null,
    AWAITING_FULFILMENT: null,
    AWAITING_COMPLETION: null,
    ACKNOWLEDGED: null,
    REQUESTED: null,
    ACCEPTED: null,
    UNKNOWN: null,
    ACTIVE: null,
    HOTLISTED: null,
    HOTLIST_REQUESTED: null,
    HOTLIST_ACCEPTED: null,
    HOTLIST_LIVE: null,
    HOTLIST_ERROR: null,
    SPOILED: null,
    PENDING: null,
    CANCELLED: null,
    EXPIRED: null,
});

export const SmartcardProgress = {
    IN_PROGRESS: 'inProgress',
    NOT_STARTED: 'notStarted',
    COMPLETED: 'completed',
};

export const SmartcardProductStatus = keyMirror({
    PENDING: null,
    AWAITING_DISTRIBUTION: null,
    UPDATE_AWAITING_DISTRIBUTION: null,
    AVAILABLE_FOR_COLLECTION: null,
    UPDATE_AVAILABLE_FOR_COLLECTION: null,
    ACTIVE: null,
    HOTLISTED: null,
    DELETED: null,
    BLOCKED: null,
    REJECTED: null,
    UPDATE_REJECTED: null,
    CANCELLED: null,
    FULFILLING: null,
    REQUESTED: null,
    INACTIVE: null,
    CANCELLING: null,
});

export const SmartcardProductStatusGroup = {
    PENDING: [
        SmartcardProductStatus.PENDING,
        SmartcardProductStatus.AWAITING_DISTRIBUTION,
        SmartcardProductStatus.UPDATE_AWAITING_DISTRIBUTION,
        SmartcardProductStatus.AVAILABLE_FOR_COLLECTION,
        SmartcardProductStatus.UPDATE_AVAILABLE_FOR_COLLECTION,
        SmartcardProductStatus.REQUESTED,
        SmartcardProductStatus.FULFILLING,
    ],
    CURRENT: [SmartcardProductStatus.ACTIVE, SmartcardProductStatus.HOTLISTED],
    ACTIVE: [SmartcardProductStatus.ACTIVE],
};

export const SmartcardProductStatusText = {
    [SmartcardProductStatus.PENDING]: 'account.smartcard.product.status.pending',
    [SmartcardProductStatus.AWAITING_DISTRIBUTION]:
        'account.smartcard.product.status.sendingToStation',
    [SmartcardProductStatus.UPDATE_AWAITING_DISTRIBUTION]:
        'account.smartcard.product.status.sendingTopupToStation',
    [SmartcardProductStatus.AVAILABLE_FOR_COLLECTION]:
        'account.smartcard.product.status.readyToCollect',
    [SmartcardProductStatus.UPDATE_AVAILABLE_FOR_COLLECTION]:
        'account.smartcard.product.status.topupReadyToCollect',
    [SmartcardProductStatus.ACTIVE]: 'account.smartcard.product.status.loadedOnCard',
    [SmartcardProductStatus.HOTLISTED]: 'account.smartcard.product.status.productBlocked',
    [SmartcardProductStatus.DELETED]: 'account.smartcard.product.status.productRemovedFromCard',
    [SmartcardProductStatus.BLOCKED]: 'account.smartcard.product.status.productBlocked',
    [SmartcardProductStatus.REJECTED]: 'account.smartcard.product.status.errorPleaseContact',
    [SmartcardProductStatus.UPDATE_REJECTED]: 'account.smartcard.product.errorPleaseContact',
    [SmartcardProductStatus.CANCELLED]: 'account.smartcard.product.status.cancelled',
    [SmartcardProductStatus.FULFILLING]: 'account.smartcard.product.status.sendingToStation',
    [SmartcardProductStatus.REQUESTED]: 'account.smartcard.product.status.pending',
    [SmartcardProductStatus.CANCELLING]: 'account.smartcard.product.status.cancelled',
    [SmartcardProductStatus.INACTIVE]: 'account.smartcard.product.status.productBlocked',
};

export const KeyGoProductStatus = {
    LIVE: 'ACTIVE',
    PENDING_CLOSURE: 'PENDING_CLOSURE',
    PENDING: 'PENDING',
    CLOSED: 'CLOSED',
};

export const KEYGO_TOPUP_AMOUNT = 25 * 100;

export const KEYGO_NICKNAME = 'keyGo CA';

export const SmartcardReplacementReason = {
    LOST: 'lost',
    NOT_WORKING: 'not-working',
    NOT_RECEIVED: 'not-received',
    STOLEN: 'stolen',
    NAME_CHANGE: 'change-of-name',
};

export const UploadSize2mb = 2 * Math.pow(1024, 2);
export const UploadSize5mb = 5 * Math.pow(1024, 2);

export const PaymentType = {
    VOUCHER: 'cocs-voucher',
    STORED_CARD: 'paypoint-stored',
    CARD: 'paypoint-card',
    PAY360_HOSTED: 'pay360-hosted',
    PAYPAL: 'paypal-checkout',
    VISA_CHECKOUT: 'visa-checkout',
    AMAZON_PAY: 'amazon-pay',
    BRAINTREE_CARD_CHECKOUT: 'card-checkout',
};

export const PaymentAuthCodes = {
    API_ERROR: 'E900',
    API_HTTP_ERROR: 'E901',
    BAD_PRICE: 'E003',
    BAD_TRANSACTION_REFERENCE: 'E008',
    BRAND_NOT_FOUND: 'A104',
    CANCELLED: 'C000',
    CARD_NOT_FOUND: 'E007',
    DECLINED_BY_UPSTREAM_PROCESSOR: 'D100',
    ENROLLED: 'S000',
    EXPIRED: 'E000',
    FRAUD: 'F001',
    MISSING_DELIVERY: 'E012',
    NO_RESULT: 'E006',
    OK: 'S001',
    ORDER_NOT_FOUND: 'E001',
    BAD_STATE: 'E002',
    PENDING: 'S002',
    PROCESSING: 'S003',
    REFUNDED: 'R000',
    REFUNDREJECTED: 'R001',
    REJECTED_BY_FRAUD: 'A136',
    REPLACED: 'R003',
    SWAPSMARTCARD: 'R004',
    UNDER_REVIEW: 'F000',
    UNSUPPORTED_TYPE: 'E004',
    USER_NOT_VOUCHER_OWNER: 'E009',
    VOIDED: 'V000',
    VOUCHER_INSUFFICIENT_AMOUNT: 'E011',
    VOUCHER_NOT_FOUND_OR_EXPIRED: 'E010',
    AMAZON_PAY_MFA_FAILURE: 'AMAZON_PAY_MFA_FAILURE',
    AMAZON_PAY_INVALID_PAYMENT_METHOD_ERROR: 'EAP1',
    AMAZON_PAY_PAYMENT_REJECTED_ERROR: 'EAP2',
    AMAZON_PAY_PROCESSING_FAILURE_ERROR: 'EAP3',
    AMAZON_PAY_TRANSACTION_TIMEOUT_ERROR: 'EAP4',
};

export const PaymentAuthStatuses = {
    SUCCESS: 'success',
    ENROLLED: 'enrolled',
    FAILED: 'failed',
    EXPIRED: 'expired',
    CANCELLED: 'cancelled',
    VOIDED: 'voided',
    FRAUD: 'fraud',
    PENDING: 'pending',
};

export const PaymentTooltipIds = {
    PaymentMethods: 'PaymentMethods',
    OrderSummary: 'OrderSummary',
};

export const CardTypes = {
    AMEX: /^(3[47]|9905)/,
    VISA: /^(4|9903)/,
    VISA_ELECTRON: /^(4(026|17500|405|508|844|91[37])|9902)/,
    MAESTRO: /^(5018|5020|5038|6304|6759|676[1-3]|9900)/,
    MASTERCARD: /^(5[1-5]|9901)/,
};

export const VISA_CHECKOUT_BUTTON_ID = 'visa-checkout-button';

export const TripTypes = keyMirror({
    SEASON: null,
    POINT: null,
    SMARTCARD_SEASON: null,
    SMARTCARD_POINT: null,
    DAYSAVE: null,
    ROVERSRANGERS: null,
});

export const OrderTripTypes = keyMirror({
    RETURN: null,
    SEASON: null,
    SINGLE: null,
    RETURN_SINGLE: null,
    RETURN_SINGLES: null,
    DAYSAVE: null,
    FARE_ONLY: null,
    ROVERSRANGERS: null,
    SMART_CARNET: null
});

export const OrderStates = {
    INCOMPLETE: 'Incomplete',
    COMPLETE: 'Complete',
    EXPIRED: 'Expired',
    PENDING: 'Pending',
    REFUNDED: 'Refunded',
    UNDER_REVIEW: 'UnderReview',
    FULFILLED: 'Fulfilled',
    FRAUD: 'Fraud',
    AMENDING: 'Amending',
};

export const TripBookingStatus = {
    OK: 'OK',
    FAILED_NOT_REQUIRED: 'FailedButNotRequired',
    FAILED: 'Failed',
    MAPPING_ERROR: 'MappingError',
    INTERNAL_ERROR: 'InternalError',
    UPSTREAM_ERROR: 'UpstreamError',
};

export const TicketRefundStates = {
    REFUNDED: 'refunded',
    REFUNDABLE: 'refundable',
    ADVANCE_TICKET: 'not-online-advance-ticket',
    SEASON_TICKET: 'not-online-season-ticket',
    PRINTED: 'not-online-printed',
    EXCEEDED_VALIDITY: 'not-online-exceeded-refund-validity-days',
    UNKNOWN: 'unknown',
};

export const ChangeoverActions = {
    REFUND: 'refund',
    PAYMENT: 'payment',
};

export const GROUP_SAVE_CODE = 'GS3';

export const RAILCARD_CODES_WITH_FARE_AND_TIME_RESTRICTIONS = {
    HM_FORCES: 'HMF',
    NETWORK: 'NEW',
    ANNUAL_GOLD_CARD: 'NGC',
    SENIOR: 'SRN',
    RAILCARD_26_TO_30: 'TST',
    RAILCARD_16_TO_25: 'YNG',
    VETERANS: 'VET',
};

export const CardLockStatus = {
    SUCCESS: 'S00',
    BAD_REQUEST: 'V00',
    MISSING_PAN: 'V01',
    INVALID_PAN: 'V02',
    INVALID_CVV: 'V03',
    UNKNOWN_PUBLISHABLE_ID: 'A01',
    SERVICE_UNAVAILABLE: 'E00',
    INTERNAL_ERROR: 'E01',
};

export const CustomerTitles = ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr', 'Mx'];

export const TPECustomerTitles = ['Mr', 'Mrs', 'Ms', 'Miss', 'Mx', 'Dr', 'Rev', 'Lady', 'Lord', 'Sir', 'Dame'];

export const COUNTED_PLACE = '***';

export const JourneySelectorTypes = {
    OPEN: 'open',
    CLOSED: 'closed',
};

export const RailDayStart = {
    hours: 4,
    minutes: 30
};

export const MAX_NOTIFICATION_TIME = 30 * 1000;

export const LoadingTypes = keyMirror({
    SMARTCARD: null,
    API: null,
    ORDER: null,
    TRIP: null,
});

export const CookieKeys = keyMirror({
    CONFIRMED_SMARTCARDS: null,
    SMARTCARD_CTA_DISMISSED: null,
    DO_NOT_TRACK: null,
    ORDER: null,
});

export const BAlertTypes = {
    INFO: 'info',
    WARNING: 'warning',
    DANGER: 'danger',
    SUCCESS: 'success',
};

export const DRCStates = {
    PENDING: 'Pending',
    BLOCKED: 'Blocked',
    ACTIVE: 'Active',
    EXPIRED: 'Expired'
};

export const BulletinSeverity = keyMirror({
    P1: null,
});

export const IgnoredErrors = [
    /Blocked a frame with origin/g, //CORS errors usual culprit is GTM
    /Script error/g, //3rd party External Script error
    /multiple calls to tags.js/g, //Visa checkout sdk error with Firefox
    /TypeError: _jp\.\w+ is not a function/, // local webpack websocket errors
    /ResizeObserver loop limit exceeded/g, // harmless resize observer threshold error
];

export const StationFinderSearchInteractions = {
    CURRENT_LOCATION: 'current-location',
    ENTERED_LOCATION: 'entered-location',
};

export const NREIncompatibleRailcards = ['GS3'];

export const SubscriptionActions = {
    SUBSCRIBE: 'subscribe',
    UNSUBSCRIBE: 'unsubscribe',
};

export const SkipAutoLogoutRedirectRoutes = [
    AccountPages.AUTO_DELAY_REPAY,
    CompensationPages.SEASON,
    CompensationPages.NON_SEASON,
    Widgets.REFUND_WIDGET,
];

export const TicketOfficeHours = {
    CLOSING_CUT_OFF: '6:00',
    OPEN: 'open',
    CLOSED: 'closed',
    NO_OFFICE: 'no-office',
    NOT_AVAILABLE: 'not-available',
};

export const PlusBusOptions = [
    {
        direction: 'outward',
        terminal: 'origin',
    },
    {
        direction: 'outward',
        terminal: 'destination',
    },
    {
        direction: 'return',
        terminal: 'origin',
    },
    {
        direction: 'return',
        terminal: 'destination',
    },
];

export const SignupTypes = keyMirror({
    WITH_SMARTCARD: null,
    WITH_TRANSFER: null,
    WITHOUT_SMARTCARD: null,
});

export const WeekdayNames = {
    MONDAY: 'monday',
    TUESDAY: 'tuesday',
    WEDNESDAY: 'wednesday',
    THURSDAY: 'thursday',
    FRIDAY: 'friday',
    SATURDAY: 'saturday',
    SUNDAY: 'sunday',
};

export const BusinessDays = [
    WeekdayNames.MONDAY,
    WeekdayNames.TUESDAY,
    WeekdayNames.WEDNESDAY,
    WeekdayNames.THURSDAY,
    WeekdayNames.FRIDAY,
];
export const WeekDays = BusinessDays.concat([WeekdayNames.SATURDAY, WeekdayNames.SUNDAY]);

export const InitialWeekDayJourney = 'weekday';
export const WeekDaysJourney = [InitialWeekDayJourney, WeekdayNames.SATURDAY, WeekdayNames.SUNDAY];

export const Railcard1617States = keyMirror({
    ACCEPTED: null,
});

export const RAILCARD1617_CODE = 'TSU';
export const JOB_CENTRE_PLUS_RAILCARD_CODE = 'JCP';

export const KeyGoJourneyStates = keyMirror({
    INCOMPLETE_PROVISIONAL: null,
    COMPLETE_PROVISIONAL: null,
    INCOMPLETE_FINAL: null,
    COMPLETE_FINAL: null,
});

export const KeyGoTapStatus = keyMirror({
    GENERATED: null,
    VALID: null,
});

export const KeyGoTapTypes = keyMirror({
    INSPECTION: null,
    ENTRY: null,
    EXIT: null,
});

export const KeyGoTapGenerationCause = keyMirror({
    TOUCH: null,
    MULTI_USE_BOUNDARY: null,
    GATELINE_AUTOCOMPLETE: null,
    SINGLE_USE_BOUNDARY: null,
    AUTO_SAME_STATION_EXIT: null,
    AUTOFILL: null,
    CORRECTION: null,
    MANUALFILL: null,
    UNKNOWN: null,
});

export const KeyGoTapGenerationCauseText = {
    [KeyGoTapGenerationCause.TOUCH]: 'account.smartcard.keygo.journeyhistory.touch',
    [KeyGoTapGenerationCause.MULTI_USE_BOUNDARY]:
        'account.smartcard.keygo.journeyhistory.multiUseBoundary',
    [KeyGoTapGenerationCause.GATELINE_AUTOCOMPLETE]:
        'account.smartcard.keygo.journeyhistory.gatelineAutocomplete',
    [KeyGoTapGenerationCause.SINGLE_USE_BOUNDARY]:
        'account.smartcard.keygo.journeyhistory.singleUseBoundary',
    [KeyGoTapGenerationCause.AUTO_SAME_STATION_EXIT]:
        'account.smartcard.keygo.journeyhistory.autoSameStationExit',
    [KeyGoTapGenerationCause.AUTOFILL]: 'account.smartcard.keygo.journeyhistory.autofill',
    [KeyGoTapGenerationCause.CORRECTION]: 'account.smartcard.keygo.journeyhistory.correction',
    [KeyGoTapGenerationCause.MANUALFILL]: 'account.smartcard.keygo.journeyhistory.manualfill',
    [KeyGoTapGenerationCause.UNKNOWN]: 'account.smartcard.keygo.journeyhistory.unknown',
};

export const IBlocksErrorCodes = {
    CONFLICT: 'ECF0003',
    ACCOUNT_CLOSED: 'EBR0006',
    REACHED_TAP_LIMIT: 'EBR0008',
    INVALID_TAP_TIME: 'EBR0009',
};

export const IBlocksTransitModes = keyMirror({
    RAIL: null,
    BUS: null,
});

export const WidgetLayout = {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal',
};

export const WidgetTab = {
    SEARCH: 'search',
    SEASON: 'season',
};

export const KeyGoReimbursementStatus = keyMirror({
    SUCCESS: null,
});

export const keyGoPaymentCardStatus = keyMirror({
    ACTIVE: null,
    NO_CARD: null,
    EXPIRED: null,
    EXPIRES_THIS_MONTH: null,
});

export const KeyGoHostedFollowOnActions = keyMirror({
    RegisterOnActiveCard: null,
    RegisterOnNewCard: null,
    UpdateCard: null,
    testing: null, // used for testing only, it will not register a keyGo
});

export const filteredOutRailcards = {
    keyGo: ['2TR', 'DIC', 'FAM'],
    season: ['2TR', 'DIC', 'DIS', 'FAM', 'HMF', 'JCP', 'NEW', 'NGC', 'SRN', 'TST', 'VET', 'YNG'],
};

export const filteredRailcards = {
    keyGo: ['DIS', 'HMF', 'JCP', 'NEW', 'NGC', 'SRN', 'TST', 'TSU', 'VET', 'YNG'],
    season: ['TSU'],
};

// For tests that use _.defer, let's not wait until jasmine.DEFAULT_TIMEOUT_INTERVAL
// but quit much quicker. The actual timeout value depends on host machine's CPU
// (which tend to be slow for CI/CD) so upped the value from 1 ms to 100 ms.
export const TEST_REDUCED_TIMEOUT_INTERVAL = 100;

export const AmazonPayErrors = {
    GeneralError: 'OtrlGeneralError',
    BuyerSessionExpired: 'BuyerSessionExpired',
};

export const AmazonIds = {
    ADDRESS_BOOK: 'addressBookWidgetDiv',
    BUTTON: 'AmazonPayButton',
    LOGIN_BUTTON: 'AmazonLoginButton',
    WALLET: 'walletWidgetDiv',
};

export const AmazonLoginStatus = keyMirror({
    IDLE: null,
    LINK_START: null,
    LINK_ERROR: null,
    LINK_SUCCESS: null,
    LOGIN_ERROR: null,
    LOGIN_READY_TO_AUTH: null,
    LOGIN_SUCCESS: null,
    REGISTER_START: null,
    SYNC_EMAIL_START: null,
    UNLINK_SUCCESS: null,
});

export const AmazonLoginAuthStatus = {
    LINKING_NOT_AVAILABLE: 'linking_not_available',
    LINKING_REQUIRED: 'linking_required',
    MISMATCHED_EMAILS: 'mismatched_emails',
};

export const AmazonLoginResponseType = {
    CODE: 'code',
    TOKEN: 'token',
};

export const Railcard1617Errors = {
    ALREADY_EXISTS: 'card already exists',
};

export const AllowedDeliveryCountryCodes = ['GB'];
export const AllowedSameDeliveryAddressCountries = ['United Kingdom'];

export const RefundCalculation = {
    initiatedByCustomer: 'Customer',
    initiatedByAgent: 'Customer Service',
};

export const widgetSearchElements = {
    dateSelector: 'DateSelector',
    arriveDepart: 'ArriveDepart',
    timeSelector: 'TimeSelector',
};

export const AmazonLoginCTATypes = keyMirror({
    LOGIN: null,
    REGISTER: null,
});

export const OPEN_GOLF_TICKET_CODE_REGEX = /^OG[1-48]$/;

export const OpenGolfTickets = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    EIGHT: 8,
};

export const Browsers = {
    IE9_10: 'Internet Explorer 9-10',
    IE11: 'Internet Explorer 11',
    MOZ: 'Mozilla Firefox',
    O: 'Opera',
    SAFARI: 'Safari',
    CHROME: 'Google Chrome',
    IOS_CHROME: "iOS Chrome"
};

export const FavouriteExcludedTicketTypes = [OPEN_GOLF_TICKET_CODE_REGEX];
export const FavouriteSeasonExpiringSoonThresholdDays = 7;

export const DisruptionAlertMaximumAlerts = 10;
export const DisruptionAlertMaximumServices = 5;
export const DisruptionAlertPrimaryDateFormat = 'ddd DD MMM YYYY';
export const DisruptionAlertDurationOptions = keyMirror({
    INFINITE: null,
    SIXMONTHS: null,
    ONEOFF: null,
    CUSTOM: null,
});
export const DisruptionAlertDaysOptions = keyMirror({
    WEEKDAYS: null,
    SATURDAYS: null,
    SUNDAYS: null,
});
export const DisruptionAlertWeekdays = keyMirror({
    MONDAY: null,
    TUESDAY: null,
    WEDNESDAY: null,
    THURSDAY: null,
    FRIDAY: null,
});
export const DisruptionAlertReactivationOptions = keyMirror({
    NEVER: null,
    DAY: null,
    WEEK: null,
    MONTH: null,
    CUSTOM: null,
});

export const DisabledPeopleRailcards = ['DIS', 'DIC'];

export const GOTriggers = {
    SERVICES_GRID: 'OTRL:page:services-grid',
};

export const SundryCodes = {
    BOOKING_FEE: 91354,
    TRAINHUGGER_DISCOUNT: 55555, //TEMP VALUE
};

export const Pay360SessionState = keyMirror({
    CREATING: null,
    READY: null,
    INVALID: null,
    SUCCESS: null,
    FAILED: null,
    CANCELLED: null,
});

export const AssociationStatuses = keyMirror({
    pending: null,
    approved: null
});

export const AssociationDetailsType = keyMirror({
    client: null,
    smartcard: null,
});

export const FlexiSeasonValidation = {
    PASSES_PER_FLEXI: 8
};

export const SmartCarnetTicketCodes = {
    PEAK: '0BI',
    OFF_PEAK: '0BK'
};

export const SmartCarnetValidation = {
    PASSES_PER_BOOK: 5
};

export const SmartCarnetTicketStatus = {
    ACTIVE: '1',
    EXPIRED: '2',
    ALL: '3'
};

export const JPWidgetConf = {
    ID: 'JP_WIDGET',
};

export const STICKET_PHOTOCARD = 'sTicket';

export const RegistrationReferrers = keyMirror({
    REGISTER_MODAL: null,
    PAYMENT_FORM: null,
    DELAY_REPAY: null,
});

export const RefundReasons = {
    UNUSED_TICKETS: 6,
    ETICKET_UNUSED_TICKETS: 12,
};

export const ValidityPeriods = {
    DAY: "0001",
    ETICKET_DAY: "0002"
};

export const DEFAULT_APP_CHANNEL = 'app';
export const WEBVIEW_BOOKING_FLOW_APP_CHANNEL = 'app-2021'; // 1.x.x and by mistake 2.0.0
export const NATIVE_BOOKING_FLOW_APP_CHANNEL = 'app-2022'; // 2.x.x
export const GATWICK_APP_CHANNEL = 'app-gx'; // 3.x.x
export const GREATNORTHERN_APP_CHANNEL = 'app-gn'; // 3.x.x
export const SOUTHERN_APP_CHANNEL = 'app-sn'; // 3.x.x
export const THAMESLINK_APP_CHANNEL = 'app-tl'; // 3.x.x

export const OrderSummaryContexts = keyMirror({
    'BASKET_MODAL': null,
    'PAYMENT_CONFIRMATION': null,
});

export const PlusBusSectionsContext = keyMirror({
    'REORDER_MODAL': null,
});

export const notificationPreferences = {
    APP_AND_EMAIL: 'appAndEmail',
    APP: 'app',
    EMAIL: 'email',
};

export const oneClickDelayRepayReimbursementMethods = {
    BACS: 'bacs',
    PAYPAL: 'paypal',
    EVOUCHERS: 'e-vouchers',
    CHARITY: 'rail-charity',
};

export const OYSTER_BUTTON_TYPE = {
    BASKET: 'BASKET',
    CTA: 'CTA',
    WEEKLY_CAP_ICON: 'WEEKLY_CAP_ICON'
};

export const STicketErrors = {
    NOT_AVAILABLE_ON_ROUTE: "SticketDeliveryOptionIsNotAvailableOnRoute",
    TOO_MANY_TICKETS_IN_BASKET: "TooManyTicketsInBasketError",
};

export const JourneySupportPaths = {
    STEP_FREE_GREEN: '/images/step-free-green.svg',
    STEP_FREE_ORANGE: '/images/step-free-orange.svg',
    STEP_FREE_RED: '/images/step-free-red.svg',

    SEATING_GREEN: '/images/seating-green.svg',
    SEATING_LIGHT_GREEN: '/images/seating-light-green.svg',
    SEATING_YELLOW: '/images/seating-yellow.svg',
    SEATING_ORANGE: '/images/seating-orange.svg',
    SEATING_RED: '/images/seating-red.svg',
    SEATING_NO_DATA: '/images/seating-no-data.svg',
};

export const StationStepFreeAccessLevels = {
    WHOLE_STATION: 'wholeStation',
    PARTIAL_STATION: 'partialStation',
    NO_PART_OF_STATION: 'noPartOfStation',
};

export const CARBON_FOOTPRINT_DATA = {
    CAR_EMISSIONS_PER_MILE: 0.22469,
    TRAIN_EMISSIONS_PER_MILE: 0.07150,
    BULB_PER_KG: 0.0075,
    KETTLE_PER_KG: 0.047,
    MICROWAVE_PER_KG: 0.406,
    PHONE_PER_KG: 0.008197,
    TV_PER_KG: 0.086,
    WASHING_MACHINE_PER_KG: 0.273,
};

export const TicketBenefitsPaths = {
    FIRST: '/images/logos/southeastern-logo-app.png',
    SECOND: '/images/paperless.png',
    THIRD: '/images/contactless.png',
};

export const SmartcardBenefitsPaths = {
    FIRST: '/images/logos/southeastern-logo-app.png',
    SECOND: '/images/tap-through.png',
    THIRD: '/images/travelcard-ready.png',
};

export const IconFillColours = {
    southeastern: '#009ADB',
    gatwick: '#DC0A1E',
    greatnorthern: '#43165C',
    southern: '#003f2E',
    ticketyboo: '#E95A0C',
    thameslink: '#E9418B',
};

export const TrainTypes = {
    DIRECT: 'direct',
    MULTILEG: 'multi,'
};

export const Directions = {
    RETURN: 'Return',
    OUTBOUND: 'Outbound',
};

export const RESERVATION_NOT_POSSIBLE = 'NotPossible';

export const RESERVATION_CANCELLATION_STATUS = {
    SUCCESS: 'Success',
    FAILURE: 'Failure',
};

export const ReservationStepIndex = {
    INIT: 0,
    SEARCH: 1,
    OUTWARD: 2,
    INWARD: 3,
    PREFERENCES: 4,
    SUMMARY: 5,
};

export const ReservationTabs = {
    UPCOMING: 'upcoming',
    PREVIOUS: 'previous',
};

export const ReservationSalesFlowType = keyMirror({
    SALES: null,
    AFTER_SALES: null,
});

export const ReservationBundleOutcome = keyMirror({
    FULL_AVAILABILITY: null,
    PARTIAL_AVAILABILITY: null,
    NO_AVAILABILITY: null,
    NO_TARIFF: null,
    SERVICE_FULL: null,
});

export const TransPennineStaffRoverNlcCodes = {
    ORIGIN: 'Z031',
    DESTINATION: 'Z032',
};



// WEBPACK FOOTER //
// ./src/constants/AppConstants.js